import React, { useState, useEffect } from "react";
import './Volunteer_registration.css'
import axios from "axios";
import validation from './Validation'
import { Link, useNavigate } from 'react-router-dom';
import bg from '../../assets/Candidate assets/Volunteer-register.png';
import logo from  '../../assets/placementlogob.png'
import { toast } from 'react-toastify';
import LoadingSpinner from '../Utils/LoadingSpinner'


function Volunteer_registration() {
    const [loader,setLoader] = useState(true);

    let navigate = useNavigate();
    const [values, setValues] = useState({
        first_name: '',
        email: '',
        phone: '',
        password: '',
        Confirm_password: ''


    })
    const [passtype ,setPassType] = useState('password');
    const [passtype2 ,setPassType2] = useState('password');
    const [errorMessage,setErrorMessage] = useState("")
    const [errors, setErrors] = useState({})

    const handleInput = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value })
        setErrors( { ...errors, [e.target.name]: "" });

    }
    function handleSubmit(e) {
        e.preventDefault();
    }

    const doAuthenticate = () => {

        const validationstatus = validation(values)
        if (!validationstatus.status) {
            setErrors(validationstatus.errors);
            console.log(errors);
        }
        else {

            // if (values.first_name !== "" || values.password !== "" || values.Confirm_Password !== "") {
            axios.post('https://pl.aspireitacademy.com/volunteersadd', {
                first_name: values.first_name,
                email: values.email,
                phone: parseInt(values.phone),
                password: values.password

            })
                .then(res => {

                if(res.data !== "Phone Number Already Exists" && 
                res.data !== "Email Already Exists"){
                        let data = res.data[0].id;
                        if(data !==''){
                            localStorage.setItem("user", JSON.stringify(res.data));
                            let user = JSON.parse(localStorage.getItem("user"));
                            navigate('/Edit_profile', {
                                state: {
                                    user: user,
                                }
                            });
                            toast.success('Registration Successful');
                        }
                        else{ 
                            toast.error('Something Went Wrong', {
                                toastId: 'errvolreg1',
                            });
                        }
                }
                else{
                        toast.error(res.data.trim(), {
                            toastId: 'errvolreg2',
                        });
                    }
                   
                })
            
        }
    }
    useEffect(()=>{
        setLoader(false);
    },[])
  //password hide & seek toggle
  const handleToggle =()=>{
    passtype==='password'? setPassType('text'): setPassType('password')
}
const handleToggle2 =()=>{
    passtype2==='password'? setPassType2('text'): setPassType2('password')
}


    return (

        <section className="h-100 w-100">
            {loader? <LoadingSpinner/>:
               <div className="container-fluid">
<div className="row p-0">
    <div className="col-md-6 col-12 sgn-bg-img" 
            style={{backgroundImage:`url(${bg})`}} >

            <div className="sgn-intro">
                <h1 >
                Thank You for being a<br />Volunteer
                    </h1>
               <Link to="/Candidate_Login" className="sgn-nav-link">Are you a Candidate?</Link><br/>
               <Link to="/skill-test" className="sgn-nav-link">Exam Page</Link>

            </div>
                
    </div>
    <div className="col-md-6 col-12 sgn-bg-color" style={{padding:'0px 15px 0px'}}>
        <div className="sgn-content" >
            <div className="sgn-header text-center ">
                <img src={logo} alt="logo" width="250px" height="70px" className="mb-4" />
                {/* <div className="sgn-page-switcher align-self-end">
                <Link  to="/Volunteer_login" className="sgn-switcher-text"  style={{color:'#000'}}>
                        Login</Link>
                <Link to="/Volunteer_registration" className="sgn-switcher-text"  style={{color:'#1F8A70'}} >Register</Link>
                </div> */}
            </div>
            <div className="sgn-form">
            <h5 className="mb-3"> Volunteer Registration</h5>
            <form onSubmit={handleSubmit}>
            
            <div className="form-group sgn-from-group reg-form-grp" >
                <input type="text" 
                name="first_name"
                className="form-control sgn-input" 
                placeholder="Enter Name" 
                id="name"
                onChange={handleInput} />
                <span className="reg-error-msg"> {errors.first_name ? errors.first_name:''}</span>
                </div>


                <div className="form-group sgn-from-group reg-form-grp">
                <input type="email" 
                name="email"
                className="form-control sgn-input"   
                placeholder="Enter Email" 
                onChange={handleInput}
                /> 
                 <span className="reg-error-msg">{errors.email?errors.email:''}</span>
                </div>

            <div className="form-group sgn-from-group reg-form-grp">
                <input type="number" 
                name="phone"
                className="form-control sgn-input" 
              
                minLength="10"
                maxLength="10"
                placeholder="Enter Phone Number" 
                onChange={handleInput}
                />
                 <span className="reg-error-msg">{errors.phone?errors.phone:''}</span>
                
            </div>
            <div className="form-group sgn-from-group reg-form-grp">
                    <input type={passtype}
                        name="password"
                        className="form-control  sgn-input" 
                       
                        placeholder="Password" 
                        onChange={handleInput}/>
                    <i className={passtype === 'password'?"fa fa-eye-slash" : "fa fa-eye"}
                         id="sgn-pass-tog" style={{top:'37%'}}
                        onClick={handleToggle}></i>
                <span className="reg-error-msg" style={{height:'18px'}}>{errors.password?errors.password:''}</span>
            </div>
            <div className="form-group sgn-from-group reg-form-grp">
                    <input type={passtype2}
                        name="Confirm_password"
                        className="form-control  sgn-input" 
                     
                        placeholder="Confirm Password" 
                        onChange={handleInput}/>
                    <i className={passtype2 === 'password'?"fa fa-eye-slash" : "fa fa-eye"}
                         id="sgn-pass-tog" style={{top:'37%'}}
                        onClick={handleToggle2}></i>
            <span className="reg-error-msg">{errors.Confirm_password?errors.Confirm_password:''}</span>
                </div>


            <div className="form-group sgn-from-group reg-form-grp">
                <div className="sgn-content-between">
                <button type="submit"
                 className="btn btn-primary sgn-btn"
                 style={{backgroundColor:'#1F8A70'} }
                 onClick={() => doAuthenticate()}
                 >Register</button> 
                  <div>
                      <Link className="text-decoration-none" to="/Volunteer_login"> 
                          <span className="text-black me-2 text-muted" >Already have an account? 
                          </span> <b>Sign In</b>
                      </Link>
                   </div>
                </div>
            
            </div>

            
            </form>
            </div>
        </div>

    </div>
</div>
</div>
}
        </section>

    );
}
export default Volunteer_registration;